import Vue from 'vue'
import Vuex from 'vuex'

import createPersistedState from "vuex-persistedstate"

Vue.use(Vuex);

const store = new Vuex.Store({
    plugins: [createPersistedState()],

    state: {
        user: {}
    },

    mutations: {
        handleUser: (state, data) => {
            state.user = data;
        },

        deleteUser: (state, data) => {
            state.user = data;
        }
    },

    getters: {
        user: (state) => state.user
    }
})

export default {store}